import { gql } from 'graphql-request';


export const PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT = gql`
    fragment ProcessRequestExecutionStateFields on ProcessRequestExecutionState {
        requestId
        process
				profileId
				companyId
				companyHotelId
        state
        result
				statistics {
            taskStatistics {
                total
                succeeded
                failed
                isFinished
                isEmpty
            }
            triggerStatistics {
                total
                succeeded
                failed
                isFinished
                isEmpty
            }
        }
        
    }
`